export class ChangePasswordModel {
	OldPassword: string;
    NewPassword: string;
	ConfirmPassword: string;
}

export class ChangePasswordUserModel {
	UserId:string;
	NewPassword: string;
	ConfirmPassword: string;
}

export class ForgotPasswordModel {
	UserName: string;
}

export class ResetPasswordModel {
	UserId: string;
	Password: string;
    ConfirmPassword: string;
	Code: string;
}




// WEBPACK FOOTER //
// ./src/app/models/inModels/ChangePasswordModel.ts